export default "__VITE_ASSET__BShCb7ne__"